if (typeof FeaturedReviews === 'undefined') {
    class FeaturedReviews extends HTMLElement {
        connectedCallback() {
            const swiperEl = this.querySelector('.swiper');
            if (!swiperEl || this.swiper) return;

            whenReady('Swiper', () => {
                try {
                    this.swiper = new Swiper(swiperEl, {
                        loop: true,
                        a11y: true,
                        spaceBetween: 20,
                        slidesPerView: "auto",
                        watchSlidesProgress: true,
                        navigation: {
                            nextEl: this.closest(".shopify-section").querySelector('.swiper-next'),
                        },
                        pagination: {
                            el: this.closest(".shopify-section").querySelector('.swiper-pagination'),
                            clickable: true
                        },
                        mousewheel: { forceToAxis: true, thresholdDelta: 12 },
                        breakpoints: {
                            1025: { 
                                slidesPerView: 3,
                                spaceBetween: 16,
                            },
                        },
                        modules: [Swiper.A11y, Swiper.Mousewheel, Swiper.Navigation, Swiper.Pagination]
                    });
                } catch (error) {
                    console.error('FeaturedReviews: Failed to initialize Swiper:', error);
                }
            });
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }
    }

    if (!window.customElements.get('featured-reviews')) {
        window.customElements.define('featured-reviews', FeaturedReviews);
    }
}
